var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsta = function SvgInsta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#535C79",
    d: "M9 1.5c2.038 0 2.292.008 3.092.045.798.038 1.342.163 1.82.349.495.19.912.448 1.33.865.38.374.676.828.864 1.329.185.477.311 1.022.349 1.82.035.8.045 1.054.045 3.092s-.008 2.292-.045 3.092c-.037.798-.163 1.342-.349 1.82-.188.501-.483.955-.865 1.33a3.7 3.7 0 0 1-1.328.864c-.478.185-1.023.311-1.822.349-.799.035-1.053.045-3.091.045s-2.292-.008-3.091-.045-1.343-.163-1.821-.349a3.7 3.7 0 0 1-1.33-.865 3.7 3.7 0 0 1-.864-1.328c-.186-.478-.311-1.023-.349-1.822C1.51 11.293 1.5 11.039 1.5 9s.008-2.292.045-3.091c.038-.8.163-1.343.349-1.821.187-.501.483-.955.865-1.33a3.7 3.7 0 0 1 1.329-.864c.478-.186 1.021-.311 1.82-.349C6.709 1.51 6.963 1.5 9 1.5m0 3.75a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m4.875-.187a.938.938 0 1 0-1.875 0 .938.938 0 0 0 1.875 0M9 6.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgInsta;